import { render, staticRenderFns } from "./SiteOverDue.vue?vue&type=template&id=56256d3c&"
import script from "./SiteOverDue.vue?vue&type=script&lang=js&"
export * from "./SiteOverDue.vue?vue&type=script&lang=js&"
import style0 from "./SiteOverDue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports